import { Box, Button, Card, CardContent, Chip, Container, IconButton, Link, ListItemIcon, ListItemText, MenuItem, Tooltip, Typography } from "@mui/material";
import { FC, UIEvent, useEffect, useMemo, useRef, useState } from "react";

import { isEmpty, startCase } from "lodash";
import MaterialReactTable from "material-react-table";
import { useHistory } from "react-router-dom";
import { API_SLUGS, ROUTES, TOOL_TYPES } from "../../constants";
import { useTableInfinity } from "../../hooks/process/useTableInfinity";
import TruncatedScrollingText from "../common/truncatedScrollingText";
import { ColumnHeaderFilter } from "../analysis/ViewIssues/IssuesTable";
import { convertDurationIntoHoursMinutesSeconds, displayDateTime, displayDateTimeWithTimezone } from "../../utils/conversions";
import { Download } from "@mui/icons-material";
import { getConfigs } from "../../configs";
import { downloadCSV } from "../../utils/downlodCSV";
import { Labels } from "../analysis/ViewFindings/runComponents/labels";

const limit = 30;
const disableInfiniteScroll = false;

const UsersTable: FC<any> = ({ groupId, projectId }) => {
    const path = API_SLUGS.USERS_REPORT + `?limit={limit}&offset={offset}`;
    const tableContainerRef = useRef<HTMLDivElement>(null);

    const [columnHeaderFilter, setColumnHeaderFilter] = useState<any>({});
    const [isDownloading, setIsDownloading] = useState(false);
    const usersReportUrl = useMemo(() => {
        let newPath = path
        if (!isEmpty(columnHeaderFilter)) {
            for (let key in columnHeaderFilter) {
                const columnFilterValues = columnHeaderFilter[key];
                for (let value of columnFilterValues) {
                    if (value !== null) {
                        newPath += `&${key}=${value}`;
                    }
                }
            }
        }
        return newPath;
    }
        , [columnHeaderFilter, path])
    const { rows, fetchMoreOnBottomReached, isFetching } = useTableInfinity(
        "usersReport",
        usersReportUrl,
        tableContainerRef,
        limit
    );


    const downloadCSVReport = async () => {
        setIsDownloading(true);
        await downloadCSV(`${getConfigs().baseApiUrl}${API_SLUGS.USERS_REPORT}?downloadCsv=true`, `aptori_users_report`)
        setIsDownloading(false);
    };

    useEffect(() => {
        if (!disableInfiniteScroll) {
            fetchMoreOnBottomReached(tableContainerRef.current);
        }
    }, [fetchMoreOnBottomReached])

    const navigate = useHistory();
    return (
        <Box
            sx={{
                backgroundColor: 'background.paper',
                minHeight: '100%',
            }}
        >

            <Container maxWidth={false} sx={{ p: 3, pt: 1.5 }}>
                <Box>
                    <Box sx={{ display: "flex", justifyContent: "end", pb: 2 }}>
                        <Button
                            size="small"
                            variant="outlined"
                            onClick={() => !isDownloading && downloadCSVReport()}
                            sx={{ color: "text.primary", borderColor: "neutral.300" }}
                        >
                            <Box sx={{ display: "flex", justifyContent: "start" }}>
                                <Download fontSize="small" />
                                Download CSV Report

                            </Box>
                        </Button>
                    </Box>

                    <Box
                        sx={{
                            flexGrow: 1,
                        }}
                    >




                        <MaterialReactTable muiTablePaperProps={{
                            elevation: 0
                        }} enableGlobalFilter={false}
                            columns={[
                                {
                                    accessorKey: "email",
                                    header: "Email",
                                    size: 130
                                    
                                },
                                {
                                    accessorKey: "role",
                                    header: "Role",


                                    Cell: (params: any) => {
                                        return (
                                            <>{startCase(params?.row?.original?.role || "")}</>
                                        )
                                    },
                                    size: 100
                                },
                                {
                                    accessorKey: "createdAt",
                                    header: "Joined On",


                                    Cell: (params: any) => (
                                        <>{displayDateTimeWithTimezone(params?.row?.original?.createdAt)}</>
                                    ),
                                    size: 150
                                },
                                {
                                    accessorKey: "lastLoginDetails.loginTimestamp",
                                    header: "Last Login",


                                    Cell: (params: any) => (
                                        <>{displayDateTimeWithTimezone(params?.row?.original?.lastLoginDetails?.loginTimestamp)}</>
                                    ),
                                    size: 300
                                },

                            ]}
                            data={rows}
                            initialState={{
                                density: "compact",
                                columnPinning: { left: ['email'] },
                                columnSizing: {
                                    email: 130,       
                                  }
                            }}
                            enableColumnActions={false}
                            enableSorting={false}
                            enableStickyHeader


                            enableTopToolbar={false}

                            enablePagination={false}
                            enableDensityToggle={false}
                            enableColumnFilters={false}                          
                            // enableRowVirtualization
                            state={{
                                showProgressBars: isFetching,
                            }}
                            muiTableContainerProps={{
                                ref: tableContainerRef, //get access to the table container element
                                sx: { maxHeight: "calc(100vh - 350px)" }, //give the table a max height
                                onScroll: (
                                    event: UIEvent<HTMLDivElement> //add an event listener to the table container element
                                ) => {
                                    if (!disableInfiniteScroll) {
                                        fetchMoreOnBottomReached(event.target as HTMLDivElement)
                                    }

                                }
                            }}
                        />

                    </Box>
                </Box>

            </Container>
        </Box>

    );
};

export default UsersTable;